var AssessmentService = require('./assessment-service');
var CourseModuleService = require('./course-module-service');
var CustomizationService = require('./customization-service');
var EnrollmentService = require('./enrollment-service');
var ModuleService = require('./module-service');
var ModulesCollectionService = require('./modules-collection-service');
var PageService = require('./page-service');
var PollService = require('./poll-service');
var ProgressService = require('./progress-service');
var SiteService = require('./site-service');
var SurveyService = require('./survey-service');
var ResourceService = require('./resource-service');

var HomeRoomProvider = function() {};

module.exports = {
  AssessmentService,
  CourseModuleService,
  CustomizationService,
  EnrollmentService,
  ModuleService,
  ModulesCollectionService,
  PageService,  
  PollService,
  ProgressService,
  SiteService,
  SurveyService,
  ResourceService
};


